import {Label, Stack, Text} from "@fluentui/react";
import {theme} from "..";
import "../styles/MakeSQLResponseTable.css";

interface IMakeSQLResponseTable {
    sqlQueryResponse: any[][] | Record<string, any[][]> | undefined;
    isMultiCompany?: boolean;
    inline?: boolean;
}

export const MakeSQLResponseTable = ({
                                         sqlQueryResponse,
                                         isMultiCompany,
                                         inline
                                     }: IMakeSQLResponseTable): JSX.Element | null => {
    if (!sqlQueryResponse) {
        return null;
    }

    const isMulti = Boolean(isMultiCompany) && !Array.isArray(sqlQueryResponse);
    const companyKeys = isMulti ? Object.keys(sqlQueryResponse as Record<string, any[][]>) : ["Osnovno"];

    const getResponsesForCompany = (company: string): any[][] | undefined => {
        if (isMulti) {
            const multiResponse = sqlQueryResponse as Record<string, any[][]>;
            return multiResponse[company];
        }

        return Array.isArray(sqlQueryResponse) ? sqlQueryResponse : undefined;
    };

    return (
        <>
            {companyKeys.map((company) =>
                getResponsesForCompany(company)?.map(
                    (res, index) =>
                        (
                            <Stack className="table-container">
                                <Label
                                    style={{
                                        background: `linear-gradient(to left, transparent, ${theme.palette.themePrimary})`,
                                        color: "white",
                                        paddingLeft: 10,
                                    }}
                                >
                                    {isMulti ? `${company} - ` : ""}Rezultat {index + 1}
                                </Label>
                                <table
                                    className="results-sql-table"
                                    style={{borderCollapse: "collapse", overflow: "scroll"}}
                                >
                                    {res && res.length && (
                                        <>
                                            <thead style={{position: "sticky"}}>
                                            <tr>
                                                <td
                                                    style={{
                                                        padding: 5,
                                                        border: "1px solid lightgray",
                                                    }}
                                                >
                                                    {index ? `${index}` : "#"}
                                                </td>
                                                {Object.keys(res[0]).map((k) => (
                                                    <td
                                                        style={{
                                                            padding: 5,
                                                            whiteSpace: "nowrap",
                                                            border: "1px solid lightgray",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {k}
                                                    </td>
                                                ))}
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {res.map((r, index) => (
                                                <tr>
                                                    <td
                                                        style={{
                                                            padding: 5,
                                                            border: "1px solid lightgray",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        <Text>
                                                            {index + 1}
                                                        </Text>
                                                    </td>
                                                    {r &&
                                                        Object.keys(r).map((m) => {
                                                            const color = (r[m] === null) ? "red" : undefined;

                                                            return (
                                                                <td
                                                                    style={{
                                                                        padding: 5,
                                                                        whiteSpace: "nowrap",
                                                                        border: "1px solid lightgray",
                                                                        color,
                                                                    }}
                                                                >
                                                                    <Text style={{
                                                                        color
                                                                    }}>
                                                                        <span style={{color}}>
                                                                            {`${r[m]}`}
                                                                        </span>
                                                                    </Text>
                                                                </td>
                                                            );
                                                        })}
                                                </tr>
                                            ))}
                                            </tbody>
                                        </>
                                    )}
                                </table>
                            </Stack>
                        ) as any,
                ),
            )}
        </>
    );
};
